import { render, staticRenderFns } from "@/client/budget/views/mandate-signature/nif-validation/nif-validation.pug?vue&type=template&id=1c6fd572&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/mandate-signature/nif-validation/nif-validation.scss?vue&type=style&index=0&id=1c6fd572&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6fd572",
  null
  
)

export default component.exports